import React from "react";
const guidancePath = "/iceholidays-assets/images/visa/visa-guidance.png";

class IceVisaAboutPage extends React.Component {
  state = { showFullDescription: false, };
  componentDidMount() {}

  render() {
    return (
      <div className="ice-visa-about-page">
        <div className="container">
          <section className="visa-about-banner">
            <div className="visa-about-banner__content">
              <div className="visa-about-banner__text">
                <img className="visa-about-banner__gd-visa-logo"
                    src="/iceholidays-assets/images/GD_Visa_logo.png"
                    alt="gd visa logo"
                />
                <h1>About GD Visa</h1>
                <div>
                    <p className={`visa-about-banner__description ${
                        this.state.showFullDescription
                        ? "visa-about-banner__description--expanded"
                        : ""
                    }`}
                    >
                    GD Visa is a professional visa solutions provider offering
                    reliable and comprehensive visa support through B2B and B2C2B
                    business models. Backed by the experience and network of
                    Golden Destinations (GD), we deliver efficient end-to-end visa
                    services with a strong focus on professionalism, accuracy,
                    and service excellence, creating greater value for our
                    business partners and their customers.
                    </p>

                    <button type="button"
                        className="visa-about-banner__read-more"
                        onClick={() =>
                            this.setState({
                            showFullDescription: !this.state.showFullDescription,
                            })
                        }
                    >
                        {this.state.showFullDescription ? "Read Less" : "Read More"}
                    </button>
                </div>
                <a
                  href="https://wa.me/message/B3A4PXBDEROVL1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="visa-about-banner__whatsapp"
                >
                  <img
                    src="/iceholidays-assets/images/social/ico_whatsapp.png"
                    alt="WhatsApp"
                  />
                  <span className="visa-about-banner__whatsapp-icon">
                    <i className="bi bi-whatsapp" />
                  </span>

                  <span>WhatsApp Us</span>
                </a>
                <p className="visa-about-banner__tagline">
                    GD Visa – Your Trusted Visa Solutions Partner.
                </p>
              </div>
              <div className="visa-about-banner__image">
                <div className="visa-about-banner__image-main">
                    <img src="/iceholidays-assets/images/visa/about-visa-img-1.png" alt="" />
                </div>
                <div className="visa-about-banner__image-circle">
                    <img src="/iceholidays-assets/images/visa/about-visa-img-2.png" alt="" />
                </div>
            </div>
            </div>
          </section>

          <section className="visa-about-guidance">
            <div className="visa-about-guidance__content">
                <div className="visa-about-guidance__image">
                    <img
                        src={guidancePath}
                        alt="Professional visa guidance"
                    />
                </div>
                <div className="visa-about-guidance__info">
                <h2>Professional Guidance for Visa Success</h2>
                <p className="visa-about-guidance__description">
                    Travellers rely on our experienced team for clear, reliable visa
                    guidance from the beginning to finish.
                </p>
                <div className="visa-about-guidance__stats">
                    <div className="visa-about-stat">
                        <strong>Average 98%</strong>
                        <span>Approval rate</span>
                    </div>
                    <div className="visa-about-stat">
                        <strong>21+</strong>
                        <span>Destinations covered</span>
                    </div>
                    <div className="visa-about-stat">
                        <strong>1,000 +</strong>
                        <span>Applications completed</span>
                    </div>
                    <div className="visa-about-stat">
                        <strong>700+</strong>
                        <span>GD Travel Agents support nationwide</span>
                    </div>
                </div>
            </div>

            </div>
          </section>

          <section className="visa-about-destinations">
            <h3>Our Popular Visa Destinations – and beyond</h3>
            <div className="visa-about-destinations__list">
                <div className="visa-about-destination">
                    <img  className="visa-about-flag"
                        src="/iceholidays-assets/images/visa/flag-of-china.png"
                        alt="China"
                    />
                    <span>China</span>
                </div>
                <div className="visa-about-destination">
                    <img  className="visa-about-flag"
                        src="/iceholidays-assets/images/visa/flag-of-taiwan.png"
                        alt="taiwan"
                    />
                    <span>Taiwan</span>
                </div>
                <div className="visa-about-destination">
                    <img  className="visa-about-flag"
                        src="/iceholidays-assets/images/visa/flag-of-canada.png"
                        alt="canada"
                    />
                    <span>Canada</span>
                </div>
                <div className="visa-about-destination">
                    <img  className="visa-about-flag"
                        src="/iceholidays-assets/images/visa/flag-of-russia.png"
                        alt="russia"
                    />
                    <span>Russia</span>
                </div>
                <div className="visa-about-destination">
                    <img  className="visa-about-flag"
                        src="/iceholidays-assets/images/visa/flag-of-south-korea.png"
                        alt="south korea"
                    />
                    <span>South Korea</span>
                </div>
                <div className="visa-about-destination">
                    <img  className="visa-about-flag"
                        src="/iceholidays-assets/images/visa/flag-of-usa.png"
                        alt="USA"
                    />
                    <span>USA</span>
                </div>
                <div className="visa-about-destination">
                    <img  className="visa-about-flag"
                        src="/iceholidays-assets/images/visa/flag-of-hongkong.png"
                        alt="Hong Kong"
                    />
                    <span>Hong Kong</span>
                </div>
                <div className="visa-about-destination">
                    <img  className="visa-about-flag"
                        src="/iceholidays-assets/images/visa/flag-of-UK.png"
                        alt="United Kingdom"
                    />
                    <span>United Kingdom</span>
                </div>
                <div className="visa-about-destination">
                    <img  className="visa-about-flag"
                        src="/iceholidays-assets/images/v3/icon-globe-grey.svg"
                        alt="globe"
                    />
                    <span>21+ Countries</span>
                </div>
            </div>
          </section>

          <section className="visa-about-why">
            <div className="visa-about-why__left">
                <h2>
                    Why Choose <span className="redText">GD Visa</span>?
                </h2>
                <p className="visa-about-why__subtitle">
                    We are a trusted Malaysian travel brand since 1991<span className="subtitle_additional_info">. Backed by dedicated handling teams.</span>
                </p>
                <h3>What we handle for you</h3>

                <ul className="visa-about-why__list">
                    <li>
                        <img
                            className="visa-about-check"
                            src="/iceholidays-assets/images/v3/icon-check-circle.svg"
                            alt=""
                        />
                        Form preparation
                    </li>
                    <li>
                        <img
                            className="visa-about-check"
                            src="/iceholidays-assets/images/v3/icon-check-circle.svg"
                            alt=""
                        />
                        Appointment booking
                    </li>
                    <li>
                        <img
                            className="visa-about-check"
                            src="/iceholidays-assets/images/v3/icon-check-circle.svg"
                            alt=""
                        />
                        Document submission
                    </li>
                    <li>
                        <img
                            className="visa-about-check"
                            src="/iceholidays-assets/images/v3/icon-check-circle.svg"
                            alt=""
                        />
                        Passport collection
                    </li>
                </ul>
            </div>

            <div className="visa-about-why__right">
                <div className="visa-about-feature">
                <img className="visa-about-feature__icon padding-7"
                     src="/iceholidays-assets/images/v3/icon-lightning.svg" />
                    <p>Responsive Customer Service<br />Team</p>
                </div>

                <div className="visa-about-feature">
                    <img className="visa-about-feature__icon"
                     src="/iceholidays-assets/images/v3/icon-clock.svg" />
                    <p>End-to-end operational support</p>
                </div>

                <div className="visa-about-feature">
                    <img className="visa-about-feature__icon"
                     src="/iceholidays-assets/images/v3/icon-globe.svg" />
                <p>
                    Choose our wide coverage of GD
                    <br />
                    Travel Agents support service
                    <br />
                    nationwide
                </p>
                </div>

                <div className="visa-about-feature">
                    <img className="visa-about-feature__icon"
                        src="/iceholidays-assets/images/v3/icon-security-check.svg" />
                <p>
                    Reliable and safe payment
                    <br />
                    gateway system
                </p>
                </div>

                <div className="visa-about-feature visa-about-feature--wide">
                    <img className="visa-about-feature__icon"
                     src="/iceholidays-assets/images/v3/icon-user-check.svg" />
                    <p>Safe when customers submit their passport.</p>
                </div>

                <p className="visa-about-why__note">
                * Insurance coverage. Terms and conditions apply.
                </p>
            </div>
          </section>

          <section className="visa-about-process">
            <div className="visa-about-process__container">
                <h2 className="visa-about-process__title">
                    A simple six-step process
                </h2>
                <div className="visa-about-process__steps">
                    <div className="visa-about-process__step">
                        <div className="visa-about-process__image">
                            <img
                                src="/iceholidays-assets/images/visa/visa-process-1.png"
                                alt="Message us"
                            />
                        </div>
                        <div className="visa-about-process__content">
                            <span className="visa-about-process__number">01</span>
                            <p>Message us</p>
                        </div>
                    </div>
                    <div className="visa-about-process__step">
                        <div className="visa-about-process__image">
                            <img
                                src="/iceholidays-assets/images/visa/visa-process-2.png"
                                alt="Send us documents"
                            />
                        </div>
                        <div className="visa-about-process__content">
                            <span className="visa-about-process__number">02</span>
                            <p>
                                Send us documents for review. Whatsapp or email at
                                {" "}
                                <a href="mailto:visa@ice-holidays.com">
                                    visa@ice-holidays.com
                                </a>
                            </p>
                        </div>
                    </div>
                    <div className="visa-about-process__step">
                        <div className="visa-about-process__image">
                            <img
                                src="/iceholidays-assets/images/visa/visa-process-3.png"
                                alt="Select a nearby GD Travel Agent"
                            />
                        </div>
                        <div className="visa-about-process__content">
                            <span className="visa-about-process__number">03</span>
                            <p>
                                Select a nearby GD
                                <span> Travel Agents to service</span>
                            </p>
                        </div>
                    </div>
                    <div className="visa-about-process__step">
                        <div className="visa-about-process__image">
                            <img
                                src="/iceholidays-assets/images/visa/visa-process-4.png"
                                alt="Payment"
                            />
                        </div>
                        <div className="visa-about-process__content">
                            <span className="visa-about-process__number">04</span>
                            <p>Payment</p>
                        </div>
                    </div>
                    <div className="visa-about-process__step">
                        <div className="visa-about-process__image">
                            <img
                                src="/iceholidays-assets/images/visa/visa-process-5.png"
                                alt="Submit Passport"
                            />
                        </div>
                        <div className="visa-about-process__content">
                            <span className="visa-about-process__number">05</span>
                            <p>Submit Passport</p>
                        </div>
                    </div>
                    <div className="visa-about-process__step">
                        <div className="visa-about-process__image">
                            <img
                                src="/iceholidays-assets/images/visa/visa-process-6.png"
                                alt="Return Passport"
                            />
                        </div>
                        <div className="visa-about-process__content">
                            <span className="visa-about-process__number">06</span>
                            <p>Return Passport</p>
                        </div>
                    </div>
                </div>
            </div>
          </section>
          <section className="visa-about-cta">
            <div className="visa-about-cta__container">
                <div className="visa-about-cta__content">
                <h2>Ready to start your application?</h2>
                <p className="visa-about-cta__subtitle">
                    Chat with our visa team now – we'll take it from here.
                </p>
                <a
                    href="https://wa.me/message/B3A4PXBDEROVL1"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="visa-about-cta__whatsapp"
                >
                    <div className="visa-about-cta__whatsapp__icon">
                    <img
                    src="/iceholidays-assets/images/social/ico_whatsapp.png"
                    alt="WhatsApp"
                    />
                    </div>
                    <span>WhatsApp Us</span>
                </a>
                <p className="visa-about-cta__description">
                    Fast, clear guidance from our visa specialists.
                </p>
                </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export default IceVisaAboutPage;